import React from 'react';

const USP_COLORS = {
  snn_knowledge_graphs: '#1976d2',
  logic_gates: '#d32f2f',
  chain_predicate: '#7b1fa2',
  cognitive_cortex: '#00838f',
  process_orchestration: '#2e7d32',
  hebbian_plasticity: '#e65100',
  cross_graph: '#4527a0',
  explainability_stack: '#00695c',
  neural_confidence: '#bf360c',
  ednl: '#ef6c00',
  zero_hallucination: '#1b5e20',
  deterministic: '#283593',
  ultra_low_cost: '#4e342e',
  graph_builder: '#0277bd',
  capability_packs: '#558b2f',
  what_if: '#6a1b9a',
  sub_100ms: '#ad1457',
};

const USP_SHORT_NAMES = {
  snn_knowledge_graphs: 'SNN KG',
  logic_gates: 'Logic Gates',
  chain_predicate: 'Chain Predicates',
  cognitive_cortex: 'Cortex',
  process_orchestration: 'Process Orch.',
  hebbian_plasticity: 'Hebbian',
  cross_graph: 'Cross-Graph',
  explainability_stack: 'Explainability',
  neural_confidence: 'Neural Confidence',
  ednl: 'EDNL',
  zero_hallucination: 'Zero Hallucination',
  deterministic: 'Deterministic',
  ultra_low_cost: 'Low Cost',
  graph_builder: 'Graph Builder',
  capability_packs: 'Cap. Packs',
  what_if: 'What-If',
  sub_100ms: '<100ms',
};

const DemoUSPBadges = ({ uspTags = [], size = 'normal' }) => {
  if (!uspTags || uspTags.length === 0) return null;

  const isSmall = size === 'small';

  return (
    <div className="demo-usp-badges" style={{ display: 'flex', flexWrap: 'wrap', gap: isSmall ? 4 : 6 }}>
      {uspTags.map(tag => (
        <span
          key={tag}
          className="demo-usp-badge"
          style={{
            display: 'inline-block',
            padding: isSmall ? '2px 6px' : '3px 8px',
            borderRadius: 12,
            fontSize: isSmall ? 10 : 11,
            fontWeight: 600,
            color: 'white',
            backgroundColor: USP_COLORS[tag] || '#616161',
            whiteSpace: 'nowrap',
            lineHeight: 1.4,
          }}
        >
          {USP_SHORT_NAMES[tag] || tag}
        </span>
      ))}
    </div>
  );
};

export { USP_COLORS, USP_SHORT_NAMES };
export default DemoUSPBadges;
